/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import { LockOutlined, MailOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Form, Input, message } from 'antd';
import LoginWithGoogle from 'components/loginWithGoogle';
import LoginWithSlack from 'components/loginWithSlack';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { login } from 'services/api/users';
import ProfileContext from 'services/profileContext';
import styles from 'styles/login.module.scss';
import { isAdmin, isConnected } from 'utils/utils';

const Login = () => {
  const [showLoginWithEmail, setShowLoginWithEmail] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const profileContext = useContext(ProfileContext);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isConnected()) {
      navigate(
        profileContext && isAdmin(profileContext.profile)
          ? '/cycles'
          : '/my/cycles'
      );
    }
  }, []);

  useEffect(() => {
    const erromsg = searchParams.get('error');
    if (erromsg && erromsg.length > 0 && erromsg === 'USER_NOT_FOUND') {
      message.error(
        <div>
          No account found, <a href="/#/register">register?</a>
        </div>
      );
    }
  }, [searchParams]);

  const onFinish = (values) => {
    setLoading(true);
    login({ email: values.email.trim(), password: values.password })
      .then(() => {
        return profileContext?.updateProfile().then((data) => {
          navigate(isAdmin(data) ? '/cycles' : '/my/cycles');
        });
      })
      .catch((e) => {
        console.error(e);
        message.error('Issue when trying to login, please try again.');
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.vignetteWrapper}>
          <div className={styles.vignetteInner}>
            <div>
              <img
                src="/img/logo.png"
                width={130}
                height={130}
                alt="SimplePerf logo"
                className={styles.logo}
              />
            </div>
            <h1>Login to SimplePerf</h1>
            <div>
              {showLoginWithEmail ? (
                <>
                  <Form layout="vertical" onFinish={onFinish}>
                    <Form.Item
                      label="Email"
                      name="email"
                      placeholder="Enter your email"
                      rules={[
                        {
                          required: true,
                          message: 'Please input your email',
                        },
                      ]}
                    >
                      <Input
                        size={'large'}
                        prefix={<UserOutlined />}
                        placeholder="Enter your email"
                        type="email"
                      />
                    </Form.Item>

                    <Form.Item
                      label="Password"
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: 'Please input your password',
                        },
                      ]}
                    >
                      <Input.Password
                        size={'large'}
                        prefix={<LockOutlined />}
                        placeholder="Enter your password"
                      />
                    </Form.Item>
                    <Form.Item>
                      <Button
                        size={'large'}
                        type="primary"
                        block
                        htmlType={'submit'}
                        loading={loading}
                      >
                        Login
                      </Button>
                    </Form.Item>
                  </Form>
                </>
              ) : (
                <div style={{ marginTop: 38, marginBottom: 14 }}>
                  <Button
                    size={'large'}
                    type="primary"
                    block
                    style={{ marginBottom: 12 }}
                    onClick={() => {
                      setShowLoginWithEmail(true);
                    }}
                    icon={<MailOutlined />}
                  >
                    Sign in with Email
                  </Button>
                  <LoginWithGoogle />
                  <LoginWithSlack />
                </div>
              )}

              <div className={styles.actions}>
                {showLoginWithEmail ? (
                  <>
                    <a href="/#/forgot-password">
                      <Button type="link">Forgot your password?</Button>
                    </a>{' '}
                    <a
                      onClick={() => {
                        setShowLoginWithEmail(false);
                      }}
                    >
                      <Button type="link">Show other Login options</Button>
                    </a>
                  </>
                ) : (
                  <a href="/#/register">
                    <Button type="link">
                      Don't have an account yet? Register
                    </Button>
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
